import React from 'react'
import { useTranslation } from 'react-i18next'
import { CardIcon, CardText, CardTitle, Card, CardTitleContainer } from '../sections.style'
import { useGetUser } from '@hooks/useAuth'
import { useHistory, useLocation } from 'react-router-dom'
import useGetOpenOrders from '@hooks/useGetOpenOrders'
import CarpayOrderCard from '@components/CarpayOrderCard/CarpayOrderCard.component'
import { getFragmentData } from 'parkdepot-shared/gql'
import { OrderResponseFragment } from '@graphql/queries/getOpenOrders.query'
import { NetworkStatus } from '@apollo/client'
import Spinner from 'parkdepot-shared/components/Spinner'
import carpayHomeRoute from '@views/Carpay/Home/route.const'
import carpayOrderListRoute from '@views/Carpay/OrderList/route.const'
import { carpayPaidOrderRoute } from '@views/Carpay/PaidOrder/route.const'

const CarpaySection = () => {
    const { user } = useGetUser()
    const location = useLocation()
    const { t } = useTranslation()
    const history = useHistory()

    const { data, networkStatus, loading } = useGetOpenOrders({
        variables: { plates: user?.license_plates?.map((lp) => lp.plate) ?? [] },
        skip: !user || !user?.license_plates?.length,
        notifyOnNetworkStatusChange: true,
        pollInterval: 30000
    })

    const isPolling = networkStatus === NetworkStatus.poll
    const queryparams = new URLSearchParams(location.search)

    const handleEnterCarpayFlow = () => {
        history.push(`${carpayHomeRoute}?${queryparams.toString()}`)
    }

    return (
        <div>
            <CardTitleContainer>
                <CardTitle>{t('home.parkingProcedure')}</CardTitle>

                {isPolling || loading ? <Spinner /> : null}
            </CardTitleContainer>

            {data?.b2c_get_open_orders.orders.map((resp) => {
                const orderResponse = getFragmentData(OrderResponseFragment, resp)
                return (
                    <CarpayOrderCard
                        key={orderResponse.order.order_id}
                        data={orderResponse}
                        isLast={false}
                        onClick={() => {
                            if (orderResponse.order.status === 'PAID') {
                                history.push(
                                    `${carpayPaidOrderRoute}?plate=${orderResponse.order.plate}&order_id=${
                                        orderResponse.order.order_id
                                    }&${queryparams.toString()}`
                                )
                            } else {
                                history.push(
                                    `${carpayOrderListRoute}?plate=${orderResponse.order.plate}&order_id=${
                                        orderResponse.order.order_id
                                    }&${queryparams.toString()}`
                                )
                            }
                        }}
                    />
                )
            })}

            <Card $colored={!user} onClick={handleEnterCarpayFlow}>
                <CardIcon
                    data-testid="search-or-pay-button"
                    className={user ? 'wemolo-search' : 'wemolo-parking-sign'}
                    aria-hidden="true"
                    $white={!user}
                />
                <CardText $white={!user}>{user ? t('home.searchParkingEvent') : t('home.procedurePayment')}</CardText>
            </Card>
        </div>
    )
}

export default CarpaySection
